import React from "react";
import styles from "./Divider.module.scss";

export const Divider = () => {
  return <hr className={styles.divider} />;
};
